"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  root: {
    '&:active': {
      boxShadow: '0px 7px 8px -4px rgba(0,0,0,0.12), 0px 12px 17px 2px rgba(0,0,0,0.04), 0px 5px 22px 4px rgba(0,0,0,0.02)'
    }
  }
};